import { render, staticRenderFns } from "./MyCommissions.vue?vue&type=template&id=592e96a7&scoped=true&"
import script from "./MyCommissions.vue?vue&type=script&lang=js&"
export * from "./MyCommissions.vue?vue&type=script&lang=js&"
import style0 from "./MyCommissions.vue?vue&type=style&index=0&id=592e96a7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592e96a7",
  null
  
)

export default component.exports